export default {"src":"/_next/static/media/spring-sale.abeef177.svg","height":108,"width":210,"blurWidth":0,"blurHeight":0};